import { useCallback, useEffect, useState } from "react";
import { useDolfinClient, useDolfinAuth } from "@/components/DolfinProvider";

interface BankDetailsConfigured {
  loading: boolean;
  configured: boolean;
  refresh: () => Promise<void>;
}

export function useBankDetailsConfigured(): BankDetailsConfigured {
  const api = useDolfinClient();
  const { organisationId } = useDolfinAuth();
  const [loading, setLoading] = useState(true);
  const [configured, setConfigured] = useState(false);

  const fetchStatus = useCallback(async () => {
    if (!organisationId) return;
    setLoading(true);

    // Bank details live on the org's AR settings, not the organisation.
    const { data: ar } = await api.GET("/v1/organisations/{organisationId}/settings/ar", {
      params: { path: { organisationId } },
    });

    setConfigured(
      !!(
        ar?.bankDetails?.accountHolderName &&
        ar?.bankDetails?.country &&
        ar?.bankDetails?.currency &&
        (ar.bankDetails.accountNumber || ar.bankDetails.iban || ar.bankDetails.routingNumber)
      ),
    );

    setLoading(false);
  }, [api, organisationId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { loading, configured, refresh: fetchStatus };
}
